import { required, optional, array, obj } from 'AppReact/schema';

const profile = {
  active: optional('boolean'),
  bio: optional('string'),
  id: optional('integer'),
  image: optional('string'),
  title: optional('string')
};

const role = {
  name: optional('string'),
  id: optional('integer'),
  role_id: optional('integer'),
};

export const minAdmin = {
  id: required('integer'),
  name: required('string'),
  email: optional('string'),
  image: optional('string'),
  reset_pw: required('boolean'),
  active: required('boolean'),
  is_super_admin: required('boolean'),
  properties: array('integer'),
  roles: array('string'),
}

export default {
  active: optional('boolean'),
  email: optional('string'),
  admin_type: optional('string'),
  last_login: optional('jsDate'),
  id: required('integer'),
  is_super_admin: optional('boolean'),
  name: optional('string'),
  profile: obj(profile),
  property_ids: array('integer'),
  region_ids: array('integer'),
  reset_pw: optional('boolean'),
  created_at: required('string'),
  roles: array(obj(role)),
  username: optional('string')
};
